<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_pick_technology')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        Now that you understand the technology tree layout, let's learn how to select technologies to research!
      </p>
      <p class="pb-2">
        Each technology card shows its cost in science points <GenericIcon type="science" /> and what benefits the technology will give you.
      </p>
      <p class="pb-2">
        The legend on the right top will explain what each icon means. But you can also click on the card and get a detailed description of what each technology does.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Please select your first research target.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        Go to Research
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Done!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>